import { BaseListComponent } from 'src/app/shared/components/base-list-component/base-list-component';
import { ToastrManager } from 'ng6-toastr-notifications';
import { AuthService } from './../../../shared/services/auth.service';
import { Component, Injector } from '@angular/core';
import { CategoryService } from '../services/category.service';
import { Category } from '../models/category.model';

@Component({
  selector: 'ng-category-list',
  templateUrl: 'category-list.component.html'
})
export class CategoryListComponent extends BaseListComponent<Category> {

   constructor(
    public categoyServ:CategoryService,
    public injector:Injector,
    public auth:AuthService,
    public toastr:ToastrManager,
  ){
    super(categoyServ, injector, 'category', {editUrl:'/admin/settings/category/edit', createUrl:'/admin/settings/category/new'});
  }
 
  protected tableProprieties(): string[] {
    return [
        'Código',
        'Categoria'
    ]
  }

  protected initChildMethods(): void {}
  protected initChildProprieties(): void {}
  

}
